import { lazy } from "react"
import type { IHomeBackgroundListItem } from "store/apis/homeBackgroundAPI"

export const HOME_MODALS = {
  homeBackgroundPreview: {
    component: lazy(() => import("modals/ui/home/background-preview-modal")),
    params: {} as {
      background: IHomeBackgroundListItem
    }
  }
}
